import { render } from "./GrupoMaterialForm.vue?vue&type=template&id=478c9716&scoped=true"
import script from "./GrupoMaterialForm.vue?vue&type=script&lang=js"
export * from "./GrupoMaterialForm.vue?vue&type=script&lang=js"

import "./GrupoMaterialForm.vue?vue&type=style&index=0&id=478c9716&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-478c9716"]])

export default __exports__